import React, { useEffect, useContext, useState, useRef } from 'react';
import { connect } from 'react-redux';

import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';

import {
  getPznData,
  isPznDataLoaded as getIsPznDataLoaded
} from 'src/universal/redux/pznData';

// context
import { OfferImpressionContext } from '../index';

const TrackPznOfferImpression = ({ pznData, isPznDataLoaded, shortName }) => {
  const impressedOffersRef = useContext(OfferImpressionContext);
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(
    () => {
      if (
        shortName &&
        isPznDataLoaded &&
        isVisible &&
        impressedOffersRef.current &&
        impressedOffersRef.current.indexOf(shortName) === -1
      ) {
        const offerForCard = pznData.pznOfferList.find(
          offer => offer.shortName === shortName
        );
        if (!offerForCard) return;

        const isSpecialOffer = offerForCard.specialIndicator === 'Y';

        const eventAsset = `compare_pzn_offer${
          isSpecialOffer ? '_special' : ''
        }_${shortName}`;

        sendDTMCustomEvent({
          eventAction: 'impression',
          eventAsset: eventAsset,
          eventType: 'pageInteraction'
        });

        impressedOffersRef.current.push(shortName);
      }
    },
    [shortName, isPznDataLoaded, pznData, impressedOffersRef, isVisible]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );
    const element = elementRef.current;
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);
  return <div ref={elementRef} />;
};

const mapStateToProps = state => ({
  pznData: getPznData(state),
  isPznDataLoaded: getIsPznDataLoaded(state)
});

export default connect(mapStateToProps)(TrackPznOfferImpression);
